<template>
  <div class="analysisOnline">
    <el-container>
      <el-aside width="160px" height="100%" class="analysis_menu">
        <div>
          <el-menu
            class="el-menu-vertical-demo"
            @select="handleSelect"
            :default-active="activePage"
          >
            <el-menu-item index="/home/edit/analysis">
              <i class="el-icon-location"></i>
              <span slot="title">回收概况</span>
            </el-menu-item>
            <el-menu-item index="/home/edit/sampleData">
              <i class="el-icon-menu"></i>
              <span slot="title">样本数据</span>
            </el-menu-item>
            <el-menu-item index="/home/edit/singleAnalysis">
              <i class="el-icon-document"></i>
              <span slot="title">单题分析</span>
            </el-menu-item>
            <el-menu-item index="/home/edit/crossAnalysis">
              <i class="el-icon-setting"></i>
              <span slot="title">交叉分析</span>
            </el-menu-item>
          </el-menu>
        </div>
      </el-aside>
      <el-main class="analysis_content">
        <router-view :surveyTitle="title"></router-view>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "analysisOnline",
  props: ["title"],
  watch: {
    "$route.path": function() {
      this.activePage = this.$route.path;
    }
  },
  data() {
    return {
      activePage: "/home/edit/analysis",
      role: window.sessionStorage.getItem("role")
    };
  },
  computed: {
    ...mapGetters(["surveyType"])
  },
  mounted() {
    this.activePage = this.$route.path;
  },
  methods: {
    handleSelect(key, keyPath) {
      let { id } = this.$route.query;
      this.activePage = key;
      this.$router.push({
        path: key,
        query: {
          id: id,
          title: this.title,
          tab: "analysis"
        }
      });
    }
  }
};
</script>
<style lang="scss">
div.analysisOnline {
  height: calc(100% - 60px);
  .header-row {
    height: 55px;
    .sample-title {
      font-size: 20px;
    }
    .page-dataType {
      width: 110px;
    }
    .el-date-editor--timerange.el-input__inner {
      width: 300px;
    }
  }
  .analysis_menu {
    background-color: #fff;
  }
  .el-container {
    height: 100%;
  }
  .el-menu-item {
    height: 100px;
    line-height: 100px;
    border-bottom: 1px solid #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/analysisOnline.vue